import {
  COMPETITION_LEVEL_TYPES,
  URL_OPTION_TYPES,
  LANGUAGE_TYPES,
  NETWORK_TYPES,
  CONTROL_TYPES,
  SEARCH_VOLUME_CHART_TYPE,
  SEARCH_VOLUME_LOCATION_LEVEL,
  GRID_TYPES,
  GRID_LEVELS,
  LAYOUT_MODE,
  DeviceTypes,
  EST_BUTTON_TYPE,
  EST_DEVICE_DROPDOWN_TYPE,
  TRAFFIC_EST_CHART_TYPE,
  EST_DATA_TYPE,
  PAGE_TYPES,
  LANDING_PAGE_OPTIONS,
} from './consts';

export const settingsConfig = {
  [CONTROL_TYPES.LANGUAGE]: {
    controlId: CONTROL_TYPES.LANGUAGE,
    title: _TL_('Language'),
    description: _TL_('The location view varies based on the language input'),
  },
  [CONTROL_TYPES.LOCATION]: {
    controlId: CONTROL_TYPES.LOCATION,
    title: _TL_('Location'),
    description: _TL_('Locations may vary depending on the language you selected previously. For broader location targeting, please select a different language. Which location would you like to target?'),
  },
  [CONTROL_TYPES.NETWORK]: {
    controlId: CONTROL_TYPES.NETWORK,
  },
  [CONTROL_TYPES.NETWORK]: {
    controlId: CONTROL_TYPES.NETWORK,
    title: _TL_('Microsoft Advertising Network'),
    description: _TL_('Choose your network:'),
  },
  [CONTROL_TYPES.NEGATIVE_KEYWORD]: {
    controlId: CONTROL_TYPES.NEGATIVE_KEYWORD,
    title: _TL_('Negative keywords'),
    description: _TL_('Enter your negative keywords:'),
  },
  [CONTROL_TYPES.DATE_RANGE]: {
    controlId: CONTROL_TYPES.DATE_RANGE,
    title: _TL_('Date range'),
    description: _TL_('Show average monthly searches for:'),
  },
  [CONTROL_TYPES.KEYWORD_FILTERS_GROUP]: {
    controlId: CONTROL_TYPES.KEYWORD_FILTERS_GROUP,
    title: _TL_('Keyword Filters'),
  },
  [CONTROL_TYPES.ACCOUNT_KEYWORD_DEDUPE]: {
    controlId: CONTROL_TYPES.ACCOUNT_KEYWORD_DEDUPE,
    title: _TL_('Keyword Options'),
  },
  [CONTROL_TYPES.INCLUDED_KEYWORD]: {
    controlId: CONTROL_TYPES.INCLUDED_KEYWORD,
    title: _TL_('Keywords to include'),
    description: _TL_('Only include keywords containing the following terms'),
  },
};

export const urlOptions = {
  [URL_OPTION_TYPES.DOMAIN]: {
    id: URL_OPTION_TYPES.DOMAIN,
    text: _TL_('Use the entire site'),
  },
  [URL_OPTION_TYPES.PAGE]: {
    id: URL_OPTION_TYPES.PAGE,
    text: _TL_('Use only this page'),
  },
};

export const languageOptions = {
  [LANGUAGE_TYPES.ENGLISH]: {
    id: LANGUAGE_TYPES.ENGLISH,
    text: _TL_('English'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  [LANGUAGE_TYPES.GERMAN]: {
    id: LANGUAGE_TYPES.GERMAN,
    text: _TL_('German'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  [LANGUAGE_TYPES.FRENCH]: {
    id: LANGUAGE_TYPES.FRENCH,
    text: _TL_('French'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  [LANGUAGE_TYPES.DUTCH]: {
    id: LANGUAGE_TYPES.DUTCH,
    text: _TL_('Dutch'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  [LANGUAGE_TYPES.SPANISH]: {
    id: LANGUAGE_TYPES.SPANISH,
    text: _TL_('Spanish'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  [LANGUAGE_TYPES.ALBANIAN]: {
    id: LANGUAGE_TYPES.ALBANIAN,
    text: _TL_('Albanian'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  [LANGUAGE_TYPES.ARABIC]: {
    id: LANGUAGE_TYPES.ARABIC,
    text: _TL_('Arabic'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  [LANGUAGE_TYPES.BOSNIAN]: {
    id: LANGUAGE_TYPES.BOSNIAN,
    text: _TL_('Bosnian'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  [LANGUAGE_TYPES.BULGARIAN]: {
    id: LANGUAGE_TYPES.BULGARIAN,
    text: _TL_('Bulgarian'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  [LANGUAGE_TYPES.CROATIAN]: {
    id: LANGUAGE_TYPES.CROATIAN,
    text: _TL_('Croatian'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  [LANGUAGE_TYPES.CZECH]: {
    id: LANGUAGE_TYPES.CZECH,
    text: _TL_('Czech'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  [LANGUAGE_TYPES.DANISH]: {
    id: LANGUAGE_TYPES.DANISH,
    text: _TL_('Danish'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  [LANGUAGE_TYPES.ESTONIAN]: {
    id: LANGUAGE_TYPES.ESTONIAN,
    text: _TL_('Estonian'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  [LANGUAGE_TYPES.FINNISH]: {
    id: LANGUAGE_TYPES.FINNISH,
    text: _TL_('Finnish'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  [LANGUAGE_TYPES.GREEK]: {
    id: LANGUAGE_TYPES.GREEK,
    text: _TL_('Greek'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  [LANGUAGE_TYPES.HEBREW]: {
    id: LANGUAGE_TYPES.HEBREW,
    text: _TL_('Hebrew'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  [LANGUAGE_TYPES.HINDI]: {
    id: LANGUAGE_TYPES.HINDI,
    text: _TL_('Hindi'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  [LANGUAGE_TYPES.HUNGARIAN]: {
    id: LANGUAGE_TYPES.HUNGARIAN,
    text: _TL_('Hungarian'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  [LANGUAGE_TYPES.ICELANDIC]: {
    id: LANGUAGE_TYPES.ICELANDIC,
    text: _TL_('Icelandic'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  [LANGUAGE_TYPES.INDONESIAN]: {
    id: LANGUAGE_TYPES.INDONESIAN,
    text: _TL_('Indonesian'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  [LANGUAGE_TYPES.ITALIAN]: {
    id: LANGUAGE_TYPES.ITALIAN,
    text: _TL_('Italian'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  [LANGUAGE_TYPES.JAPANESE]: {
    id: LANGUAGE_TYPES.JAPANESE,
    text: _TL_('Japanese'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  [LANGUAGE_TYPES.LATVIAN]: {
    id: LANGUAGE_TYPES.LATVIAN,
    text: _TL_('Latvian'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  [LANGUAGE_TYPES.LITHUANIAN]: {
    id: LANGUAGE_TYPES.LITHUANIAN,
    text: _TL_('Lithuanian'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  [LANGUAGE_TYPES.MACEDONIAN]: {
    id: LANGUAGE_TYPES.MACEDONIAN,
    text: _TL_('Macedonian'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  [LANGUAGE_TYPES.MALTESE]: {
    id: LANGUAGE_TYPES.MALTESE,
    text: _TL_('Maltese'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  [LANGUAGE_TYPES.MALAY]: {
    id: LANGUAGE_TYPES.MALAY,
    text: _TL_('Malay'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  [LANGUAGE_TYPES.NORWEGIAN]: {
    id: LANGUAGE_TYPES.NORWEGIAN,
    text: _TL_('Norwegian'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  [LANGUAGE_TYPES.POLISH]: {
    id: LANGUAGE_TYPES.POLISH,
    text: _TL_('Polish'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  [LANGUAGE_TYPES.PORTUGUESE]: {
    id: LANGUAGE_TYPES.PORTUGUESE,
    text: _TL_('Portuguese'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  [LANGUAGE_TYPES.ROMANIAN]: {
    id: LANGUAGE_TYPES.ROMANIAN,
    text: _TL_('Romanian'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  [LANGUAGE_TYPES.RUSSIAN]: {
    id: LANGUAGE_TYPES.RUSSIAN,
    text: _TL_('Russian'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  [LANGUAGE_TYPES.SERBIAN]: {
    id: LANGUAGE_TYPES.SERBIAN,
    text: _TL_('Serbian'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  [LANGUAGE_TYPES.SLOVAK]: {
    id: LANGUAGE_TYPES.SLOVAK,
    text: _TL_('Slovak'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  [LANGUAGE_TYPES.SLOVENIAN]: {
    id: LANGUAGE_TYPES.SLOVENIAN,
    text: _TL_('Slovenian'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  [LANGUAGE_TYPES.SWEDISH]: {
    id: LANGUAGE_TYPES.SWEDISH,
    text: _TL_('Swedish'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  [LANGUAGE_TYPES.TAGALOG]: {
    id: LANGUAGE_TYPES.TAGALOG,
    text: _TL_('Tagalog'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  [LANGUAGE_TYPES.THAI]: {
    id: LANGUAGE_TYPES.THAI,
    text: _TL_('Thai'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  [LANGUAGE_TYPES.TURKISH]: {
    id: LANGUAGE_TYPES.TURKISH,
    text: _TL_('Turkish'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  [LANGUAGE_TYPES.TRADITIONAL_CHINESE]: {
    id: LANGUAGE_TYPES.TRADITIONAL_CHINESE,
    text: _TL_('Traditional Chinese'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
  [LANGUAGE_TYPES.VIETNAMESE]: {
    id: LANGUAGE_TYPES.VIETNAMESE,
    text: _TL_('Vietnamese'),
    landingPage: LANDING_PAGE_OPTIONS.U2K,
  },
};

export const languageOptionsCN = {
  [LANGUAGE_TYPES.SIMPLIFIED_CHINESE]: {
    id: LANGUAGE_TYPES.SIMPLIFIED_CHINESE,
    text: _TL_('Simplified Chinese'),
  },
};

export const networkOptions = {
  [NETWORK_TYPES.ALL]: {
    id: NETWORK_TYPES.ALL,
    text: _TL_('The entire Microsoft Advertising Network (recommended)'),
    description: _TL_('This option includes Microsoft sites and additional partner traffic for extended reach and lower cost-per-click.'),
  },
  [NETWORK_TYPES.OWNED_AND_OPERATED]: {
    id: NETWORK_TYPES.OWNED_AND_OPERATED,
    text: _TL_('Microsoft sites and select traffic'),
    description: _TL_('This option includes Microsoft sites and select partner traffic with performance and conversion rates similar to Microsoft Bing\'s.'),
  },
};

export const rangeOptions = {
  Start: {
    id: 'Start',
    text: _TL_('≥'),
  },
  End: {
    id: 'End',
    text: _TL_('≤'),
  },
};

export const competitionOptions = {
  [COMPETITION_LEVEL_TYPES.HIGH]: {
    id: COMPETITION_LEVEL_TYPES.HIGH,
    text: _TL_('High'),
  },
  [COMPETITION_LEVEL_TYPES.MEDIUM]: {
    id: COMPETITION_LEVEL_TYPES.MEDIUM,
    text: _TL_('Medium ', { comment: 'Here means competition level(like low, mid, high), not means media' }),
  },
  [COMPETITION_LEVEL_TYPES.LOW]: {
    id: COMPETITION_LEVEL_TYPES.LOW,
    text: _TL_('Low'),
  },
};

export const searchVolumeTypeOptions = {
  [SEARCH_VOLUME_CHART_TYPE.SEARCH_VOLUME_TRENDS]: {
    id: SEARCH_VOLUME_CHART_TYPE.SEARCH_VOLUME_TRENDS,
    text: _TL_('Search volume trends'),
    chartType: 'column',
    subTitle: _TL_('Average monthly searches'),
    emptyMsg: [
      _TL_('There is not enough data yet to display search volume charts.'),
      _TL_('Please try searching for different keywords.'),
    ],
  },
  [SEARCH_VOLUME_CHART_TYPE.MOBILE_TRENDS]: {
    id: SEARCH_VOLUME_CHART_TYPE.MOBILE_TRENDS,
    text: _TL_('Smartphone trends'),
    chartType: 'column',
    subTitle: _TL_('Average monthly searches'),
    series: {
      mobile: _TL_('Smartphone'),
      total: _TL_('Total'),
    },
    emptyMsg: [
      _TL_('There is not enough data yet to display search volume charts.'),
      _TL_('Please try searching for different keywords.'),
    ],
  },
  [SEARCH_VOLUME_CHART_TYPE.BREAKDOWN_BY_DEVICE]: {
    id: SEARCH_VOLUME_CHART_TYPE.BREAKDOWN_BY_DEVICE,
    text: _TL_('Breakdown by device'),
    chartType: 'pie',
    subTitle: '',
    emptyMsg: [],
  },
  [SEARCH_VOLUME_CHART_TYPE.BREAKDOWN_BY_LOCATION]: {
    id: SEARCH_VOLUME_CHART_TYPE.BREAKDOWN_BY_LOCATION,
    text: _TL_('Breakdown by location'),
    chartType: 'pie',
    subTitle: '',
    emptyMsg: [],
  },
  [SEARCH_VOLUME_CHART_TYPE.COMPARE_TO_COMPETITOR_DOMAINS]: {
    id: SEARCH_VOLUME_CHART_TYPE.COMPARE_TO_COMPETITOR_DOMAINS,
    text: _TL_('Compare to competitor domains'),
    chartType: 'column',
    subTitle: _TL_('Ad impression share'),
    emptyMsg: [_TL_('Try a different search. We only show competitor domains when there are enough keyword ideas.')],
  },
  [SEARCH_VOLUME_CHART_TYPE.COMPARE_TO_MARKET_LEADER_DOMAINS]: {
    id: SEARCH_VOLUME_CHART_TYPE.COMPARE_TO_MARKET_LEADER_DOMAINS,
    text: _TL_('Compare to market leader domains'),
    chartType: 'column',
    subTitle: _TL_('Ad impression share'),
    emptyMsg: [_TL_('Try a different search. We only show market leaders when there are enough keyword ideas.')],
  },
};

export const trafficEstChartTypeOptions = {
  [TRAFFIC_EST_CHART_TYPE.LINE_CHART]: {
    id: TRAFFIC_EST_CHART_TYPE.LINE_CHART,
    text: null,
    chartType: 'line',
    subTitle: _TL_('Weekly estimates'),
    emptyMsg: [],
  },
  [TRAFFIC_EST_CHART_TYPE.DEVICE_PIE_CHART]: {
    id: TRAFFIC_EST_CHART_TYPE.DEVICE_PIE_CHART,
    text: null,
    chartType: 'pie',
    subTitle: _TL_('Weekly estimates'),
    emptyMsg: [_TL_('Please enter a bid between {{min}} and {{max}} in the text box above.')],
  },
  [TRAFFIC_EST_CHART_TYPE.LOCATION_PIE_CHART]: {
    id: TRAFFIC_EST_CHART_TYPE.LOCATION_PIE_CHART,
    text: null,
    chartType: 'pie',
    subTitle: _TL_('Weekly estimates'),
    emptyMsg: [_TL_('Please enter a bid between {{min}} and {{max}} in the text box above.')],
  },
};

export const locationLevelOptions = {
  [SEARCH_VOLUME_LOCATION_LEVEL.STATE]: {
    id: SEARCH_VOLUME_LOCATION_LEVEL.STATE,
    text: _TL_('State/province'),
  },
  [SEARCH_VOLUME_LOCATION_LEVEL.DMA]: {
    id: SEARCH_VOLUME_LOCATION_LEVEL.DMA,
    text: _TL_('DMA/metro area'),
  },
  [SEARCH_VOLUME_LOCATION_LEVEL.CITY]: {
    id: SEARCH_VOLUME_LOCATION_LEVEL.CITY,
    text: _TL_('City'),
  },
  [SEARCH_VOLUME_LOCATION_LEVEL.TARGETED]: {
    id: SEARCH_VOLUME_LOCATION_LEVEL.TARGETED,
    text: _TL_('Targeted locations'),
  },
};

export const keywordGridOptions = {
  [GRID_TYPES.SEARCH_TERM]: {
    id: GRID_TYPES.SEARCH_TERM,
    text: _TL_('Search terms'),
  },
  [GRID_TYPES.KEYWORD_IDEA_OUTER]: {
    id: GRID_TYPES.KEYWORD_IDEA_OUTER,
    text: _TL_('Keyword (by relevance)'),
  },
};

export const layoutConfig = {
  nav: {
    mode: LAYOUT_MODE.Hidden,
  },
  menu: {
    mode: LAYOUT_MODE.Hidden,
  },
  tab: {
    mode: LAYOUT_MODE.Hidden,
  },
};

export const layoutConfigNavRefresh = {
  tab: {
    mode: LAYOUT_MODE.Collapsed,
    singleTabMode: true,
    showDatePicker: false,
  },
};

export const layoutPageConfig = {
  [PAGE_TYPES.SEARCH_PAGE]: {
    key: 'Results',
    text: _TL_('Results'),
    defaultGridLevel: GRID_LEVELS.ADGROUP,
  },
  [PAGE_TYPES.ESTIMATE_PAGE]: {
    key: 'Estimates',
    text: _TL_('Estimates'),
    defaultGridLevel: GRID_LEVELS.ADGROUP_ESTIMATE,
  },
};

export const deviceTypeConfig = {
  [DeviceTypes.Desktop]: _TL_('Computer'),
  [DeviceTypes.Mobile]: _TL_('Smartphone'),
  [DeviceTypes.Tablet]: _TL_('Tablet'),
};

const impreAndClicksOptions = {
  compact: 'short',
  minimumFractionDigits: 0,
  maximumFractionDigits: 2,
};

const monetaryOptions = {
  compact: 'short',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
};

export const estButtonOptions = {
  [EST_BUTTON_TYPE.CLICKS]: {
    id: EST_BUTTON_TYPE.CLICKS,
    text: _TL_('Clicks'),
    formatOptions: impreAndClicksOptions,
  },
  [EST_BUTTON_TYPE.IMPRESSONS]: {
    id: EST_BUTTON_TYPE.IMPRESSONS,
    text: _TL_('Impressions'),
    formatOptions: impreAndClicksOptions,
  },
  [EST_BUTTON_TYPE.SPEND]: {
    id: EST_BUTTON_TYPE.SPEND,
    text: _TL_('Spend({{currencyCode}})'),
    formatOptions: monetaryOptions,
  },
};

export const estDeviceDropdownOptions = {
  [EST_DEVICE_DROPDOWN_TYPE.BID]: {
    id: EST_DEVICE_DROPDOWN_TYPE.BID,
    text: _TL_('Bid'),
  },
  [EST_DEVICE_DROPDOWN_TYPE.DEVICE]: {
    id: EST_DEVICE_DROPDOWN_TYPE.DEVICE,
    text: _TL_('Device'),
  },
};

export const estDataOptions = {
  [EST_DATA_TYPE.CLICKS]: {
    id: EST_DATA_TYPE.CLICKS,
    text: _TL_('Clicks'),
    formatShortOptions: impreAndClicksOptions,
  },
  [EST_DATA_TYPE.IMPRESSONS]: {
    id: EST_DATA_TYPE.IMPRESSONS,
    text: _TL_('Impressions'),
    formatShortOptions: impreAndClicksOptions,
  },
  [EST_DATA_TYPE.SPEND]: {
    id: EST_DATA_TYPE.SPEND,
    text: _TL_('Spend'),
    formatShortOptions: monetaryOptions,
  },
  [EST_DATA_TYPE.MAXCPC]: {
    id: EST_DATA_TYPE.MAXCPC,
    text: _TL_('Max. CPC'),
  },
  [EST_DATA_TYPE.SCALED_BID]: {
    id: EST_DATA_TYPE.SCALED_BID,
    text: _TL_('Scaled bids'),
  },
};

